import { styledComponent } from 'lib/styled_component';
import { List } from 'aa-react-ui';

const ListWrapper = styledComponent(List)`
    height: 100%;
    margin-top: 1rem;
    overflow-y: auto;
`;

export { ListWrapper };
